import React from 'react';
import { t } from 'i18next';
import { UseFormSetValue } from 'react-hook-form';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { PaxResponseDto } from '@bandido/shared/dtos';

import { Form } from './form';

interface Props {
  setValue: UseFormSetValue<Form>;
  paxes: PaxResponseDto[];
}

export const Paxes: React.FC<Props> = ({ paxes, setValue }) => (
  <FormControl>
    <InputLabel >{t('hotels.fares.hotelPaxData.pax.useExisting')}</InputLabel>
    <Select
      size="small"
      onChange={(event) => {
        const selectedPax = paxes?.find(pax => pax.id === event.target.value);
        if (selectedPax) {
          setValue('name', selectedPax.name, { shouldValidate: true });
          setValue('surname', selectedPax.lastName, { shouldValidate: true });
          setValue('email', selectedPax.email, { shouldValidate: true });
        }
      }}
    >
      {paxes.map((pax) => (
        <MenuItem key={pax.id} value={pax.id}>
          {pax.name} {pax.lastName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
